import React, { Component, Fragment } from 'react';
import { Route }  from 'react-router-dom';
import { withRouter, Switch, Redirect } from 'react-router-dom';

import Header from '../components/Header';
import PopupFeedback from '../components/PopupFeedback';

import SearchService from './SearchService';
import ServiceList from './ServiceList';
import RouteList from './RouteList';

import withTracker from './withTracker';

class IndexPage extends Component {
  state = {
    isShowSearch: true,
    isClearSearch: false,
    station: {}
  };

  componentDidMount() {
    this.isIndexPage();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      window.scrollTo(0, 0);
      this.isIndexPage();
      this.hideMap();
    }
  }

  isIndexPage = () => {
    const withResultsClass = 'main--with-results';

    if (this.props.location.pathname === '/') {
      this.mainRef.classList.remove(withResultsClass);
    } else {
      this.mainRef.classList.add(withResultsClass);
    }
  };

  showMap = (station) => {
    this.setState({
      isShowSearch: false,
      station: station
    });
  };

  hideMap = () => {
    this.setState({
      isShowSearch: true,
    });
  };

  clearSearch = (clear) => {
    this.setState({
      isClearSearch: clear,
    });
  };

  render() {
    const { station, isShowSearch, isClearSearch } = this.state;
    const embed = window.location.hostname.includes('-embed') || window.location.hostname.includes('-webview');
    return (
      <Fragment>
        {<Header
          hideMap={this.hideMap}
          clearSearch={this.clearSearch}
          index={this.props.location.pathname === '/'}
          logoImage={'coach-tracker'}
          embed={embed}
        />}

        <div style={{ backgroundColor: '#F1F1F1' }} className="mtop">
          <div ref={(div) => (this.mainRef = div)} className={embed ? "main main__embed" : "main"}>
            {isShowSearch && (
              <SearchService
                clearSearch={this.clearSearch}
                isClearSearch={isClearSearch}
              />
            )}

            <Switch>
              <Route path="/" exact />

              <Route
                path={["/view/between/:from/:to", "/view/reference/:reference", "/view/service/:service", "/view/stop/:stop", "/view/debug-trip"]}
                render={props => (
                  <ServiceList
                    {...props}
                    showMap={this.showMap}
                    hideMap={this.hideMap}
                    clearSearch={this.clearSearch}
                    isShowSearch={isShowSearch}
                    station={station}
                  />
                )}
              />

              <Route
                path="/ticket/:hash/:email"
                render={(props) => (
                  <ServiceList
                    {...props}
                    showMap={this.showMap}
                    hideMap={this.hideMap}
                    clearSearch={this.clearSearch}
                    isShowSearch={isShowSearch}
                    station={station}
                  />
                )}
              />

              <Route
                path="/ticket-by-email/:email/:ticketid"
                render={(props) => (
                  <ServiceList
                    {...props}
                    showMap={this.showMap}
                    hideMap={this.hideMap}
                    clearSearch={this.clearSearch}
                    isShowSearch={isShowSearch}
                    station={station}
                  />
                )}
              />

              <Route
                path="/ticket-by-email/:email/:ticketid"
                render={(props) => (
                  <ServiceList
                    {...props}
                    showMap={this.showMap}
                    hideMap={this.hideMap}
                    clearSearch={this.clearSearch}
                    isShowSearch={isShowSearch}
                    station={station}
                  />
                  )}
                />
                <Route
                  path="/routes"
                  render={(props) => (
                    <RouteList
                      {...props}
                    />
                  )}
                />

              <Route
                render={() => {
                  return <Redirect to="/" />;
                }}
              />
            </Switch>
          </div>
        </div>

        <PopupFeedback />
      </Fragment>
    );
  }
}

export default withRouter(withTracker(IndexPage));



// WEBPACK FOOTER //
// ./src/containers/IndexPage.js